import { useState } from 'react';
import { X, Bug, Lightbulb, MessageCircle } from 'lucide-react';
import { useLang } from '../i18n';

const C = {
  bg: "#0d1117", surface: "#161b22", border: "#30363d",
  text: "#e6edf3", muted: "#8b949e", accent: "#3b82f6",
};

const TYPES = [
  { id: 'bug', Icon: Bug, zh: 'Bug', en: 'Bug' },
  { id: 'idea', Icon: Lightbulb, zh: '建议', en: 'Idea' },
  { id: 'other', Icon: MessageCircle, zh: '其他', en: 'Other' },
];

export function FeedbackModal({ onClose, onSubmit }) {
  const [type, setType] = useState('bug');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const { lang } = useLang();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!message.trim()) {
      setError(lang === 'en' ? 'Please describe the issue or idea' : '请填写反馈内容');
      return;
    }
    setLoading(true);
    const ok = await onSubmit(type, message.trim());
    setLoading(false);
    if (!ok) {
      setError(lang === 'en' ? 'Failed to submit, please try again later' : '提交失败，请稍后重试');
      return;
    }
    setSuccess(true);
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999 }}>
      <div style={{ background: C.surface, border: `1px solid ${C.border}`, borderRadius: 12, padding: 28, width: 380, position: 'relative' }}>
        <button onClick={onClose} style={{ position: 'absolute', top: 12, right: 12, background: 'none', border: 'none', color: C.muted, cursor: 'pointer', display: 'flex' }}><X size={18} strokeWidth={2} /></button>

        <div style={{ fontSize: 16, fontWeight: 700, color: C.text, marginBottom: 4 }}>
          {lang === 'en' ? 'Send Feedback' : '发送反馈'}
        </div>
        <div style={{ fontSize: 12, color: C.muted, marginBottom: 20 }}>
          {lang === 'en' ? 'Report a bug or share an idea — goes straight to the team.' : '报告问题或提建议，会直接发给我们。'}
        </div>

        {success ? (
          <div style={{ textAlign: 'center', color: '#10b981', padding: '16px 0', fontSize: 13 }}>
            {lang === 'en' ? 'Thanks! Your feedback was submitted.' : '谢谢！反馈已提交。'}
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
              {TYPES.map(tp => (
                <button
                  key={tp.id} type="button" onClick={() => setType(tp.id)}
                  style={{
                    flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4,
                    padding: '10px 6px', borderRadius: 8, cursor: 'pointer',
                    background: type === tp.id ? 'rgba(59,130,246,0.15)' : 'transparent',
                    border: `1px solid ${type === tp.id ? C.accent : C.border}`,
                    color: type === tp.id ? C.accent : C.muted,
                  }}
                >
                  <tp.Icon size={16} strokeWidth={2} />
                  <span style={{ fontSize: 11, fontWeight: 600 }}>{lang === 'en' ? tp.en : tp.zh}</span>
                </button>
              ))}
            </div>

            <textarea
              value={message} onChange={e => setMessage(e.target.value)}
              placeholder={lang === 'en' ? 'What happened, or what would help?' : '发生了什么，或者你希望我们做什么？'}
              autoFocus rows={5} maxLength={2000}
              style={{ width: '100%', background: C.bg, border: `1px solid ${C.border}`, borderRadius: 6, padding: '10px 12px', color: C.text, fontSize: 13, boxSizing: 'border-box', resize: 'vertical', fontFamily: 'inherit' }}
            />

            {error && <div style={{ color: '#ef4444', fontSize: 12, marginTop: 10 }}>{error}</div>}

            <button type="submit" disabled={loading}
              style={{ width: '100%', marginTop: 16, background: C.accent, border: 'none', borderRadius: 6, padding: '10px', color: '#fff', fontWeight: 600, fontSize: 14, cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1 }}>
              {loading ? (lang === 'en' ? 'Submitting...' : '提交中...') : (lang === 'en' ? 'Submit' : '提交')}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
